import { render, staticRenderFns } from "./GChatMessageBox.vue?vue&type=template&id=4f338fbb&"
import script from "./GChatMessageBox.vue?vue&type=script&lang=ts&"
export * from "./GChatMessageBox.vue?vue&type=script&lang=ts&"
import style0 from "./GChatMessageBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports